import { z } from "zod";
export const healthBehaviourSchema = z.enum(["sleep", "movement", "food", "stress", "connection"]);
/** The behaviours Heartbeat has an arm for. */
export const WATCHED_BEHAVIOURS = new Set([
    "movement",
    "sleep",
    "stress",
    "connection",
    "food",
]);
/** Food's only arms are the GLP-1 ones, so for anyone else Heartbeat is not watching it. */
export function watchedBehavioursFor(onGlp1) {
    return [...WATCHED_BEHAVIOURS].filter((b) => b !== "food" || onGlp1);
}
const HEALTH_BEHAVIOUR_SYNONYMS = {
    // food
    nutrition: "food",
    diet: "food",
    eating: "food",
    meals: "food",
    nourishment: "food",
    hydration: "food",
    // movement
    exercise: "movement",
    activity: "movement",
    workout: "movement",
    fitness: "movement",
    walking: "movement",
    steps: "movement",
    "physical activity": "movement",
    // stress
    "stress management": "stress",
    relaxation: "stress",
    recovery: "stress",
    resilience: "stress",
    mindfulness: "stress",
    // sleep
    rest: "sleep",
    "sleep recovery": "sleep",
    // connection
    social: "connection",
    relationships: "connection",
    community: "connection",
    "social connection": "connection",
};
const HEALTH_BEHAVIOUR_VALUES = healthBehaviourSchema.options;
export function coerceHealthBehaviour(raw) {
    if (typeof raw !== "string")
        return null;
    const lower = raw.trim().toLowerCase();
    if (HEALTH_BEHAVIOUR_VALUES.includes(lower)) {
        return lower;
    }
    return HEALTH_BEHAVIOUR_SYNONYMS[lower] ?? null;
}
// The member-facing label for each behaviour, shared by every surface that
// names one.
export const BEHAVIOUR_LABELS = {
    sleep: "Sleep",
    movement: "Movement",
    food: "Food",
    stress: "Stress",
    connection: "Connection",
};
//# sourceMappingURL=health-behaviours.js.map